import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_auth/referrals/settings/profile")({
  beforeLoad: () => {
    throw redirect({ to: "/referrals/directory-profile" });
  },
});
